// The game's name, in one place. The logo, page titles and copy read from
// here, so renaming the game is a change to this file.
// word: the main wordmark. tag: the short mark beside it (may be empty).
export const BRAND = {
    word: 'Rotations',
    tag: '',
};

export const BRAND_NAME = [BRAND.word, BRAND.tag].filter(Boolean).join(' ');
